$(document).ready(function () {
  
  console.log("document ready FUNCTION CALLED");
  console.log("[ARXENA INFO] \nPlease check this article https://help.arxena.com or contact our support at help@arxena.com \n\n*Submit a ticket using the link below if you think this is a bug\n");
  console.log("ready!");
  console.log("LOAD TYPE:::!", document.getElementById("load_type").getAttribute("data-row"));
  new UtilityFunctions().setUPSessionStorageVariables();
  new ProcessNodesStates().initializeSessionStorageforDropdowns();
  window.shift_key_pressed = false;
  $(document).on("keyup keydown", function (e) {
    window.shift_key_pressed = e.shiftKey;
  });
  window.mobile = false;
  var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
  if (width < 480) {
    window.mobile = true;
  }
  document.title = "Arxena's Org Charts (Global) - Arxena";
  new UtilityFunctions().runNavigation();
  new UtilityFunctions().detectModalClosuresAndCloseItems();
});

